import MainStructuresDetail from './MainStructuresDetail';

export { MainStructuresDetail };
